import * as React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import { Save } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';

import { useTranslation } from 'react-i18next';

interface SaveButtonProps extends ButtonProps {
  label?: string;
}

export default function SaveButton(props: SaveButtonProps) {
  const [t] = useTranslation();
  const { label =  t('common.confirm'),
    startIcon = <Save />,
    ...restButtonProps
  } = props;

  const {
    formState: { isDirty, isSubmitting, isValid },
  } = useFormContext();

  const disabled = !isDirty;

  const icon = isSubmitting
    ? <CircularProgress size={18} thickness={2} color="inherit" />
    : startIcon;

  return (
    <Button
      type="submit"
      variant="contained"
      color="primary"
      disabled={disabled}
      {...restButtonProps}
    >
      {label}
    </Button>
  );
}
